null


// WEBPACK FOOTER //
// /local/home/vibhorbh/workplace/Phoenix/commands/GetTextDetectionCommand.ts